import { useGlobalQuery } from '@/state/query-client/hooks';
import { useAuthStore } from '@/state/store/auth';
import {
  getActiveSubscription,
  LEGAL_TEMPLATE_DOCUMENT_GENERATION_FEATURE_ID,
  type ActiveSubscription,
} from '../services/subscription.service';

export const hasActiveDocumentGenerationSubscription = (
  subscription: ActiveSubscription | null | undefined
): boolean =>
  subscription?.Usage?.some(
    (usage) =>
      usage.FeatureId === LEGAL_TEMPLATE_DOCUMENT_GENERATION_FEATURE_ID &&
      usage.HasLicensing === true
  ) ?? false;

export const hasExhaustedDocumentGenerationQuota = (
  subscription: ActiveSubscription | null | undefined
): boolean => {
  const usage = subscription?.Usage?.find(
    (entry) =>
      entry.FeatureId === LEGAL_TEMPLATE_DOCUMENT_GENERATION_FEATURE_ID &&
      entry.HasLicensing === true
  );

  return !!usage && usage.Used >= usage.TotalLimit;
};

export const activeSubscriptionQueryKey = (
  userId: string | null,
  sigOrgId: string | null
) => ['active-subscription', userId, sigOrgId] as const;

export const useActiveSubscription = () => {
  const { isAuthenticated, userId, sigOrgId } = useAuthStore();

  return useGlobalQuery({
    queryKey: activeSubscriptionQueryKey(userId, sigOrgId),
    queryFn: getActiveSubscription,
    enabled: isAuthenticated && !!userId,
    staleTime: 5 * 60 * 1000,
    gcTime: Infinity,
    refetchOnWindowFocus: true,
  });
};
